export const environment = {
  production: true,
  apiBaseUrl: window["env"] == undefined ? '' : window["env"]["apiBaseUrl"],
  googleAnalyticsTrackingCode: window["env"] == undefined ? '' : window["env"]["googleAnalyticsTrackingCode"],
  sitePath: window["env"] == undefined ? '' : window["env"]["sitePath"],
  aiInstrumentationKey: window["env"] == undefined ? '' : window["env"]["aiInstrumentationKey"],
  googleMapsApiKey: window["env"] == undefined ? '' : window["env"]["googleMapsApiKey"],
  captchaSiteKey: window["env"] == undefined ? '' : window["env"]["captchaSiteKey"],
  publicSecureBaseUrl: window["env"] == undefined ? '' : window["env"]["publicSecureBaseUrl"]
};
